import { render, staticRenderFns } from "./CandidateInterviewResolver.vue?vue&type=template&id=05a71d7c&scoped=true&"
import script from "./CandidateInterviewResolver.vue?vue&type=script&lang=js&"
export * from "./CandidateInterviewResolver.vue?vue&type=script&lang=js&"
import style0 from "./CandidateInterviewResolver.vue?vue&type=style&index=0&id=05a71d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a71d7c",
  null
  
)

/* custom blocks */
import block0 from "./CandidateInterviewResolver.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateInterviewResolver.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardText,VDialog,VResponsive,VSelect})
